/* ==========================================================================
   SARRADIN — Theme JavaScript
   Scroll-triggered fade-in animations & smooth scroll
   ========================================================================== */

(function () {
  'use strict';

  // Skip animations in Shopify editor
  if (window.Shopify && window.Shopify.designMode) return;

  // --- Scroll-triggered fade-in ---
  var elements = document.querySelectorAll('.fade-in');

  // First mark them as ready (enables the CSS animation)
  elements.forEach(function (el) {
    el.classList.add('fade-in--ready');
  });

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );

  elements.forEach(function (el) { observer.observe(el); });

  // --- Smooth scroll for anchor links ---
  document.querySelectorAll('a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var target = document.querySelector(link.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
})();

